import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, ArrowRight, Briefcase, LineChart, Target } from 'lucide-react';
import { services } from '../data/mockData';

const KurumsalFinansman = () => {
  const service = services[2];

  const solutions = [
    {
      icon: Briefcase,
      title: 'Halka Arz Danışmanlığı',
      description: 'Şirketinizin halka açılma sürecinde profesyonel destek'
    },
    {
      icon: LineChart,
      title: 'Birleşme ve Satın Alma',
      description: 'M&A süreçlerinde stratejik danışmanlık hizmeti'
    },
    {
      icon: Target,
      title: 'Kurumsal Finansman',
      description: 'Şirket değerleme ve finansal yeniden yapılanma'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <div className="relative h-96 overflow-hidden">
        <img src={service.image} alt={service.title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 to-slate-900/70"></div>
        <div className="absolute inset-0 flex items-center">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl">
              <div className="flex items-center space-x-3 mb-4">
                <div className="bg-orange-500 p-3 rounded-lg">
                  <Building2 className="w-8 h-8 text-white" />
                </div>
                <h1 className="text-5xl font-bold text-white">{service.title}</h1>
              </div>
              <p className="text-slate-200 text-xl">{service.description}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Kurumsal Finansman Çözümlerimiz</h2>
            <div className="prose prose-lg max-w-none text-slate-700 space-y-4">
              <p>
                Turkish Menkul Değerler olarak, şirketlerin sermaye piyasalarından fon sağlama, halka açılma, birleşme ve satın alma gibi kurumsal finansman ihtiyaçlarında profesyonel danışmanlık hizmeti sunmaktayız.
              </p>
              <p>
                Deneyimli ekibimiz, sektörel uzmanlığımız ve geniş yatırımcı ağımızla şirketlerin stratejik hedeflerine ulaşmasında yanındayız.
              </p>
            </div>
          </div>

          {/* Solutions */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {solutions.map((solution) => (
              <div key={solution.title} className="bg-gradient-to-br from-slate-50 to-white rounded-xl p-6 border border-slate-200 hover:shadow-lg transition-shadow">
                <div className="bg-orange-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                  <solution.icon className="w-6 h-6 text-orange-600" />
                </div>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">{solution.title}</h3>
                <p className="text-slate-600 text-sm">{solution.description}</p>
              </div>
            ))}
          </div>

          {/* Process */}
          <div className="bg-slate-50 rounded-xl p-8 mb-12">
            <h3 className="text-2xl font-bold text-slate-900 mb-6">Süreç Aşamaları</h3>
            <div className="space-y-4">
              {['Stratejik Planlama ve Analiz', 'Piyasa İncelemesi ve Değerleme', 'Yapılandırma ve Dokumentasyon', 'Uygulama ve Takip'].map((step, idx) => (
                <div key={step} className="flex items-center space-x-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-orange-500 text-white flex items-center justify-center font-bold">
                    {idx + 1}
                  </div>
                  <div className="flex-1 bg-white rounded-lg p-4 shadow-sm">
                    <p className="font-semibold text-slate-900">{step}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-4">Şirketiniz İçin En Uygun Çözümü Bulalım</h3>
            <p className="text-orange-100 mb-6">Kurumsal finansman ihtiyaçlarınız için uzman ekibimizle görüşün</p>
            <Link
              to="/iletisim"
              className="inline-flex items-center space-x-2 bg-white text-orange-600 px-8 py-3 rounded-lg font-semibold hover:shadow-xl transition-shadow"
            >
              <span>Teklif Alın</span>
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KurumsalFinansman;